import React, { useState } from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { FaEdit } from "react-icons/fa";
import { useCustomerTagListData } from "./hooks/useCustomerTag";
import CustomerTagAddAndEditModal from "./modal/CustomerTagAddEditModal";
// import ClassificationAddAndEditModal from "./modal/ClassificationAddEditModal";
// import { useClassificationListData } from "./hooks/useClassification";

const classificationColums = (handleEditCustomerTag: (row: any) => void) => [
  {
    name: "Customer Tag",
    selector: (row: { TagName: number | string }) =>
      row.TagName,
    width: "90%",
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={() => handleEditCustomerTag(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];

const CustomerTag: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
      const [isDownloading,setIsDownloading]=useState(false)
  
  const [paginationStates, setPaginationStates] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
  });
  const [rowData, setRowData] = useState(null)
  const { data } = useCustomerTagListData({
    enable: true, params: {
      limit: paginationStates.limit,
      page: paginationStates.page,
      search: paginationStates.search,
    }
  });

  const handleEditCustomerTag = (row: any) => {
    setRowData(row)
    setCheckAddEditStatus('Edit')
    setIsModalOpen(true)
  }

  const toggleModal = () => {
    setCheckAddEditStatus('Add')
    setIsModalOpen(true);
  }

  const handlePagination = (pageNo: number) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

    const handleExcel = async () => {
  try {
    setIsDownloading(true)
    const appToken = localStorage.getItem("Apptoken") || "";

    const search = paginationStates?.search || "";
        

    const params = new URLSearchParams();

    // Append only if the value exists

  
    if (search) params.append("search", search);

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getOutletTagsListExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "Customer Classification.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }
  finally{
    setIsDownloading(false)
  }
};

  return (
    <div className="p-4">
      <PageHeader
        title="Customer Tag"
        buttons={[
          {
            label: "+Add Customer Tag",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
            {
           label: isDownloading ? "Downloading..." : "Excel",
            onClick:handleExcel,
            color: "#43B9B2",
            disable:isDownloading
          }
        ]}
      />
      <BasicDataTable
        paginationTotalRows={data?.data?.data?.Pagination?.TotalOutletTags || 0}
        onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page)
        }}
        handleSearch={(val: any) => { handleSearch(val) }}
        Title="Customer Tag"
        columns={classificationColums(handleEditCustomerTag)}
        data={data?.data?.data?.OutletTags || []}
      />
      <CustomerTagAddAndEditModal rowData={rowData} setCheckAddEditStatus={setCheckAddEditStatus}  checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus == 'Add' ? 'Add Customer Tag' : 'Edit Customer Tag'} />
    </div>
  );
};
export default CustomerTag;
